<template>
  <!-- Mismo marcado que genera b-form-group con label-cols="4" label-cols-sm="3",
       para que se vea igual que el resto de los formularios sin usar Bootstrap-Vue -->
  <div>
    <div role="group" class="form-group label">
      <div class="form-row">
        <label
          for="input-classroom-type-name"
          class="col-4 col-sm-3 col-form-label"
          >{{ $t("reusable.common.name") }}</label
        >
        <div class="col">
          <input
            id="input-classroom-type-name"
            v-model="form.name"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && !nameIsValid }"
            aria-describedby="input-classroom-type-name-live-feedback"
          />
          <div
            id="input-classroom-type-name-live-feedback"
            class="invalid-feedback"
          >
            {{ $t("reusable.common.minLength", { min: 2 }) }}
          </div>
        </div>
      </div>
    </div>
    <div role="group" class="form-group label">
      <div class="form-row">
        <label
          for="input-classroom-type-description"
          class="col-4 col-sm-3 col-form-label"
          >{{ $t("reusable.common.description") }}</label
        >
        <div class="col">
          <textarea
            id="input-classroom-type-description"
            v-model="form.description"
            rows="3"
            class="form-control form-control-sm"
          ></textarea>
        </div>
      </div>
    </div>
    <div v-if="!isNew" class="p-0 m-0 mt-2">
      <ModificationDate :Information="classroom_type"></ModificationDate>
    </div>
    <div class="row">
      <div class="col" style="text-align: right">
        <!-- Deshabilitado mientras se guarda: varios clics creaban varios registros -->
        <button
          type="button"
          class="btn btn-secondary btn-sm m-0"
          :disabled="saving"
          @click="save"
        >
          <span
            v-if="saving"
            class="spinner-border spinner-border-sm mr-1"
            aria-hidden="true"
          ></span>
          {{
            saving ? $t("reusable.common.saving") : $t("reusable.common.save")
          }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
// eslint-plugin-vue 6.x (anterior a <script setup>) no ve que estos bindings
// se usan en el template. Quitar el disable cuando se actualice el tooling.
/* eslint-disable no-unused-vars */
// Crear o editar un Tipo de sala. El orden no se edita aquí: se reordena arrastrando
// en el listado.
// Legacy (Bootstrap-Vue): ModificationDate es el pie de auditoría compartido.
import { computed, getCurrentInstance, reactive, ref } from "vue";
import * as names from "@/store/names";
import { toast } from "@/utils/utils";
import ModificationDate from "@/components/reusable/ModificationDate";

const props = defineProps({
  // Tipo de sala a editar; null para crear uno nuevo
  classroom_type: {
    type: Object,
    default: null,
  },
  // Orden con que se crea uno nuevo (al final de la lista)
  next_order: {
    type: Number,
    default: 1,
  },
});
const emit = defineEmits(["created", "updated"]);

const proxy = getCurrentInstance().proxy;

const isNew = computed(() => !props.classroom_type);
const form = reactive({
  name: props.classroom_type ? props.classroom_type.name : "",
  description: props.classroom_type ? props.classroom_type.description : "",
});
const submitted = ref(false);
const saving = ref(false);

// "Taller" o "Sala A3" son nombres válidos, así que el mínimo es corto
const nameIsValid = computed(() => form.name.trim().length >= 2);

function entityName() {
  return proxy.$getVisibleNames("mesh.classroomtype", false, "Tipo de sala");
}

function save() {
  if (saving.value) return;
  submitted.value = true;
  if (!nameIsValid.value) return;
  const item = {
    name: form.name.trim(),
    description: form.description,
  };
  if (isNew.value) item.order = props.next_order;
  saving.value = true;
  const request = isNew.value
    ? proxy.$store.dispatch(names.POST_CLASSROOM_TYPE, item)
    : proxy.$store.dispatch(names.PATCH_CLASSROOM_TYPE, {
        classroom_type_id: props.classroom_type.id,
        item: item,
      });
  // Si falla, api.js ya mostró el error: solo se vuelve a habilitar el botón
  request
    .then((response) => {
      toast(
        entityName() +
          " " +
          proxy.$t(
            isNew.value ? "reusable.common.created" : "reusable.common.updated"
          )
      );
      emit(isNew.value ? "created" : "updated", response);
    })
    .catch(() => {})
    .finally(() => {
      saving.value = false;
    });
}
</script>
